export default () => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: '操作',
    field: 'col-opt',
    align: 'left',
    headerAlign: 'center',
    width: 160,
    fixed: 'left',
    treeNode: true,
    slots: {
      default: 'opt',
    },
  },
  {
    title: '机构编号',
    field: 'orgNo',
    align: 'center',
    width: 165,
    fixed: 'left',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'number',
  },
  {
    title: '机构名称',
    field: 'orgName',
    align: 'left',
    headerAlign: 'center',
    minWidth: 250,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: '机构负责人',
    field: 'orgLeader',
    align: 'left',
    headerAlign: 'center',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: '电话',
    field: 'orgPhoneNo',
    align: 'left',
    headerAlign: 'center',
    width: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: '省份',
    field: 'provinceName',
    align: 'left',
    headerAlign: 'center',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: '城市',
    field: 'cityName',
    align: 'left',
    headerAlign: 'center',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: '区县',
    field: 'districtName',
    align: 'left',
    headerAlign: 'center',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: '详细地址',
    field: 'orgAddress',
    align: 'left',
    headerAlign: 'center',
    minWidth: 300,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'orgStatus',
    align: 'center',
    width: 100,
    title: '状态',
    slots: { default: 'status' },
  },
  {
    field: 'createByName',
    title: '创建人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'createTime',
    title: '创建时间',
    align: 'center',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'modifyByName',
    title: '修改人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'modifyTime',
    title: '修改时间',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
